import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export const copyButtonPluginKey = new PluginKey('copyButtonPlugin');
